document.addEventListener('DOMContentLoaded', function () {
    const venueCardsContainer = document.getElementById('venueResults');
    const venueCards = Array.from(document.querySelectorAll('.supplier-card'));
    const resetBtn = document.getElementById('resetFilters');
    const minGuestsEl = document.getElementById('minGuests');
    const maxGuestsEl = document.getElementById('maxGuests');
    const sortByDefaultBtn = document.querySelector('.sort-by-default');
    const sortByReviewsBtn = document.querySelector('.sort-by-reviews');
    const filterSortBy = document.querySelector('.filter-sortby');
    let currentSort = 'default';
    let guestsSlider;

    // --- Store original DOM order ---
    venueCards.forEach((card, index) => {
        card.dataset.originalOrder = index; // tier-sorted order
    });
    
    // --- Guests Slider ---
    guestsSlider = document.getElementById('guestsSlider');
    if (guestsSlider) {
        noUiSlider.create(guestsSlider, {
            start: [0, 500],
            connect: true,
            step: 10,
            range: { min: 0, max: 500 }
        });

        guestsSlider.noUiSlider.on('update', function (values) {
            minGuestsEl.textContent = Math.round(values[0]);
            maxGuestsEl.textContent = Math.round(values[1]);
            filterAndSortCards();
        });
    }

    // --- Filter + Sort Combined ---
    function filterAndSortCards() {
        const [minGuests, maxGuests] = guestsSlider ? guestsSlider.noUiSlider.get().map(Number) : [0, Infinity];

        // Filter visible cards
        const visibleCards = venueCards.filter(card => {
            const cardGuestsMin = parseInt(card.dataset.guestsMin, 10) || 0;
            const cardGuestsMax = parseInt(card.dataset.guestsMax, 10) || Infinity;
            const match = cardGuestsMax >= minGuests && cardGuestsMin <= maxGuests;
            card.style.display = match ? '' : 'none';
            return match;
        });

        // Sort visible cards
        let sortedCards = [...visibleCards];

        if (currentSort === 'reviews') {
            // Use total reviews to sort (descending)
            sortedCards.sort((a, b) => {
                const aCount = Number(a.dataset.reviewsTotal) || 0;
                const bCount = Number(b.dataset.reviewsTotal) || 0;

                // If tied, use average rating as secondary sort
                if (bCount === aCount) {
                    const aAvg = Number(a.dataset.reviewsAverage) || 0;
                    const bAvg = Number(b.dataset.reviewsAverage) || 0;
                    return bAvg - aAvg;
                }
                return bCount - aCount;
            });
        } else {
            // Default sort = original DOM order
            sortedCards.sort((a, b) => {
                return parseInt(a.dataset.originalOrder) - parseInt(b.dataset.originalOrder);
            });
        }

        // Re-append in sorted order
        sortedCards.forEach(card => venueCardsContainer.appendChild(card));
    }

    // --- Reset Filters ---
    if (resetBtn) {
        resetBtn.addEventListener('click', function (e) {
            e.preventDefault();
            if (guestsSlider) guestsSlider.noUiSlider.set([0, 500]);
            currentSort = 'default';
            sortByDefaultBtn.classList.add('active');
            sortByReviewsBtn.classList.remove('active');
            sortByDefaultBtn.querySelector('i')?.classList.replace('fa-circle', 'fa-circle-dot');
            sortByReviewsBtn.querySelector('i')?.classList.replace('fa-circle-dot', 'fa-circle');
            filterSortBy.textContent = 'Recommended';
            filterAndSortCards();
        });
    }

    // --- Sort By Buttons ---
    sortByDefaultBtn.addEventListener('click', () => {
        currentSort = 'default';
        sortByReviewsBtn.classList.remove('active');
        sortByDefaultBtn.classList.add('active');
        sortByReviewsBtn.querySelector('i')?.classList.replace('fa-circle-dot', 'fa-circle');
        sortByDefaultBtn.querySelector('i')?.classList.replace('fa-circle', 'fa-circle-dot');
        filterSortBy.textContent = sortByDefaultBtn.textContent.trim();
        filterAndSortCards();
    });

    sortByReviewsBtn.addEventListener('click', () => {
        currentSort = 'reviews';
        sortByDefaultBtn.classList.remove('active');
        sortByReviewsBtn.classList.add('active');
        sortByDefaultBtn.querySelector('i')?.classList.replace('fa-circle-dot', 'fa-circle');
        sortByReviewsBtn.querySelector('i')?.classList.replace('fa-circle', 'fa-circle-dot');
        filterSortBy.textContent = sortByReviewsBtn.textContent.trim();
        filterAndSortCards();
    });

    // --- Initial Load ---
    filterAndSortCards();
});